(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.componentContentGroupingEvents = {
    attach: function (context) {
      var selectedGrouping = $(once('slick-slider', '.component-content-grouping-events__content', context));

      selectedGrouping.each(function () {
        var slideNum = $(this).children().length;
        $(this).addClass('content-group--' + (slideNum < 4 ? slideNum : 4));
        $(this).slick({
          arrows: false,
          dots: true,
          centerMode: true,
          infinite: false,
          mobileFirst: true,
          slidesToShow: 1,
          useCss: false,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                arrows: true,
                dots: false,
                centerMode: false,
                slidesToShow: slideNum < 4 ? slideNum : 4
              }
            },
            {
              breakpoint: 1200,
              settings: {
                arrows: true,
                dots: false,
                centerMode: false,
                slidesToShow: 3
              }
            }
          ]
        });

        $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
          Drupal.blazy.init.revalidate();
        });
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
